(function () {
    'use strict';
    angular.module('app').controller('copy', copy);
    copy.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'workAreaService', 'zcs', 'selectionCommandService', 'extractionservice', 'autoNameService'];
    function copy($location, scope, $rootScope, gridDataService, $q, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, workAreaService, zcs, selectionCommandService, extractionservice, autoNameService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_COPY = 103;
        scope.xyz = { autoNameMode: false, autoNameEnable: false, autoNameList: [], bReadyForOK: false, selectedWorkAreaItem: null, bCopyDataCard: true, newName: "", maxFileNameLength: -1, selectionCount: +0, gettingWorkAreaList: true };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // On click of the command.
        scope.onCopyButtonClicked = function (slx) {

            selectionCommandService.GetMaxFilenameLength().then(function (data) {
                scope.xyz.maxFileNameLength = data;
            }, function (response) {
                selectionCommandService.ShowEx(response); // Nothing more to do.
            });

            // Ping ACS. On failure, close dialog.
            zcs.Ping(true).then(function (response) {
                // List.
                scope.slx = slx; 

                // Dialog config.
                scope.heading = loginService.resourceStrings["TITLE_COPY"];
                scope.workAreaLabel = loginService.resourceStrings["WORK_AREA"];
                scope.copyDataCardLabel = loginService.resourceStrings["COPY_DATA_CARD_AS_WELL"];
                scope.newNameLabel = loginService.resourceStrings["NEW_NAME"];
                scope.autoNameLabel = loginService.resourceStrings["AUTONAME"];
                scope.filesLabel = loginService.resourceStrings["FILES_TO_COPY"];
                scope.OK = loginService.resourceStrings["OK"]; // "OK";
                scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
                scope.defaultExtension = "";

                autoNameService.IsAutoNameEnabled().then(function (bEnabled) { scope.xyz.autoNameEnable = bEnabled; });

                // Dialog config columns.
                //scope.doColumns();
                scope.gridOptions.columnDefs = [
                  { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                  { name: 'New Name', field: 'newName', width: '33%', minWidth: '100' }];
                var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
                scope.gridOptions.columnDefs[0].name = colName;
                scope.gridOptions.columnDefs[1].name = scope.newNameLabel;

                // For each selection item, add a row to the grid.
                scope.gridOptions.data = [];
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    // Add item.
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, newName: item.filename
                    });
                    index++;
                });

                // Create a 'building list' item.
                var workAreaBuildingList = { workAreaId: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
                // Add 'building list' to the array.
                scope.workAreaList = [];
                scope.workAreaList.push(workAreaBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedWorkAreaItem = workAreaBuildingList;

                // Load Work Areas.
                workAreaService.getWorkAreas().then(function (data) {
                    var ValidationState_Valid = 1;
                    data = data.filter(function (workAreaModel) {
                        return workAreaModel.validationState == ValidationState_Valid;
                    });
                    scope.workAreaList = data;
                    if (workAreaService.currentWorkArea != null) {
                        angular.forEach(scope.workAreaList, function (workAreaItem) {
                            if (workAreaItem.workAreaId == workAreaService.currentWorkArea.workAreaId) {
                                scope.xyz.selectedWorkAreaItem = workAreaItem;
                            }
                        });
                    }
                    scope.selectedWorkAreaChanged();
                    scope.xyz.gettingWorkAreaList = false;
                });

                // Enables.
                scope.xyz.bReadyForOK = false;

                // Select rows.
                $timeout(function () {
                    refreshGrid();
                    //scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);

            }, function () {
                // Handle error.
                $mdDialog.hide();
                $rootScope.msgBoxShow(loginService.resourceStrings["ACS_FAILED_TO_CONNECT"], loginService.resourceStrings["ACS_REQUIRED"]);
            });
        };

        // =====================================
        // User interaction.
        // =====================================

        // User picked a work area.
        scope.selectedWorkAreaChanged = function () {
            scope.xyz.bReadyForOK = scope.xyz.selectedWorkAreaItem != null;
        }

        scope.onNewNameChanged = function () {
            scope.xyz.newName
            // Should only be one.
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                // If checked.
                gridItem.newName = scope.xyz.newName;
                return; // Should only be one, so return after the first.

            });
        }

        scope.applyAutoNameList = function () {
            var index = 0;
            var extension = "";

            scope.gridOptions.multiSelect = true; //temp set to true.
            scope.gridApi.selection.selectAllRows();

            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                extension = "";
                if (gridItem.name.lastIndexOf('.') > 0) {
                    extension = gridItem.name.substr(gridItem.name.lastIndexOf('.'));
                }
                gridItem.newName = scope.xyz.autoNameList[index] + extension;
                index++;
            });

            scope.gridOptions.multiSelect = false; //set back to false
            scope.gridApi.selection.clearSelectedRows(); //clear selections as they can only select one again
        }

        scope.getDefaultExtension = function () {
            if (scope.gridApi.selection.getSelectedRows().length > 0) {
                var item = scope.gridApi.selection.getSelectedRows();
                scope.defaultExtension = scope.getDocExtension(item[0].name);
            }
            else if (scope.gridOptions.data.length > 0)
                scope.defaultExtension = scope.getDocExtension(scope.gridOptions.data[0].name);

            return scope.defaultExtension;
        }

        scope.getDocExtension = function (filename) {
            var index = filename.lastIndexOf('.');
            if (index != -1)
                return filename.substr(index);
            else
                return "";
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {

            scope.xyz.selectionCount = scope.gridApi.selection.getSelectedRows().length;
            if (scope.xyz.selectionCount < 1)
                scope.xyz.newName = "";
            else {
                // Should only be one.
                angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                    // If checked.
                    scope.xyz.newName = gridItem.newName;
                    return; // Should only be one, so return after the first.
                });
            }
            if (scope.xyz.autoNameMode) {
                scope.gridApi.selection.clearSelectedRows();
                scope.xyz.newName = "";
            }
        }

        scope.onCopyDocDialogAutoName = function () {
            var deferred = $q.defer();
            scope.xyz.autoNameMode = false;

            $mdDialog.show({
                controller: 'autoNameDialog',
                templateUrl: 'app/autoname/autoNameDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: false,
                skipHide: true,
                locals: {
                    defaultExtension: scope.getDefaultExtension(),
                    numberOfDocuments: scope.gridOptions.data.length
                }
            })
                .then(function () {
                    // OK
                    if ($rootScope.dlgReturn != null && $rootScope.dlgReturn.autoNameOK == true) {
                        scope.xyz.autoNameList = $rootScope.dlgReturn.autoNameList;
                        scope.applyAutoNameList();
                        scope.xyz.autoNameMode = true;
                        scope.selectedWorkAreaChanged(); //determine if OK should be enabled.
                        scope.xyz.newName = "";
                    }
                    deferred.resolve();
                }, function () {
                    //cancel
                    deferred.reject();
                });
            return deferred.promise;
        }

        // =====================================
        // OK, Cancel.
        // =====================================

        // Take a completed results item and find it's match in the context, then update the context item.
        var UpdateContextSetWithNewFileId = function (resultsSI, slxContextSet) {
            // If the item succeceded, ...
            if (resultsSI.ec == 0) {
                // Walk the context list, ...
                angular.forEach(slxContextSet.list, function (contextItem) {
                    // If this is the item just processed, ...
                    if (contextItem.tableNumber == resultsSI.tableNumber
                        && contextItem.fileId == resultsSI.fileId
                        && contextItem.majRev == resultsSI.majRev
                        && contextItem.minRev == resultsSI.minRev) {
                        // Copy info from results to context.
                        contextItem.updateMode = resultsSI.updateMode;
                        contextItem.updateSI = resultsSI.updateSI;
                        contextItem.workAreaUpdateMode = resultsSI.workAreaUpdateMode;
                        contextItem.workAreaSI = resultsSI.workAreaSI;
                        contextItem.workAreaReplaceWithSI = resultsSI.workAreaReplaceWithSI;
                        contextItem.overwrittenFileId = resultsSI.overwrittenFileId;
                    }
                });
            }
        }

        var copyItem2 = function (gridItem, autoNameFormatModel) {
            // Must be a promise.
            var deferred = $q.defer();

            // Execute.
            // Call the WebApi to do the command.
            //filename, tableNumber, fileId, majRev, minRev, workAreaId, newName
            selectionCommandService.CopyItem(
                gridItem.selectionItem.filename, gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev,
                scope.xyz.selectedWorkAreaItem.workAreaId, scope.xyz.bCopyDataCard, gridItem.newName, scope.slxContextSet).then(function (response) {
                    // When that  returns, ...
                    var selectionCommandResults = response.data;
                    // Walk the list and add to our results list.
                    angular.forEach(selectionCommandResults.slx.list, function (si) {
                        scope.resultSLX.list.push(si);
                        UpdateContextSetWithNewFileId(si, scope.slxContextSet);
                    });

                    if (!scope.xyz.autoNameMode) {
                        // Call ACS to do the file operation.
                        zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                            var LT_LINKED = 76; // 'L'; ApiTypes.ADLINKTYPE.LT_LINKED
                            //defect id: 25115 - added ec condition to ensure good return on the previous steps
                            if (gridItem.selectionItem.detailedInfo.linkType == LT_LINKED && selectionCommandResults.slx.list[0].ec == 0) {
                                //operation packet will have have definition (wa pack)

                                //Assign extraction item property values
                                extractionservice.extractionItem.filePNE = selectionCommandResults.fileOperationPacket.fileOperations[0].destinationFile;
                                extractionservice.extractionItem.libId = ""; //blank lib id because copy is copied out to a work area
                                extractionservice.extractionItem.fileId = gridItem.selectionItem.workAreaSI.fileId;

                                //defect id: 25062
                                //changed property value set from gridItem.selectionItem to gridItem.SelectionItem.workAreaSI
                                extractionservice.extractionItem.tableNumber = gridItem.selectionItem.workAreaSI.tableNumber;
                                extractionservice.extractionItem.fileMajRev = gridItem.selectionItem.workAreaSI.majRev;
                                extractionservice.extractionItem.fileMinRev = gridItem.selectionItem.workAreaSI.minRev;

                                //promise to do the extraction for the new doc, on return update grid and show emails dialog
                                extractionservice.extractItem(extractionservice.extractionItem, false).then(function (response) {
                                    deferred.resolve();
                                }, function (error) {
                                    //there was an error with extractItem; close dialog and show error 
                                    deferred.resolve();
                                });
                            }
                            else {
                                deferred.resolve();
                            }
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });
                    }
                    else {
                        // Call ACS to do the file operation.
                        zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                            var LT_LINKED = 76; // 'L'; ApiTypes.ADLINKTYPE.LT_LINKED
                            // Update the new file after ACS has copied the file
                            autoNameService.AutoNameUpdateRecord(gridItem.selectionItem.workAreaSI, autoNameFormatModel).then(function () {
                                //defect id: 25115 - added ec condition to ensure good return on the previous steps
                                if (gridItem.selectionItem.detailedInfo.linkType == LT_LINKED && selectionCommandResults.slx.list[0].ec == 0) {
                                    autoNameService.UpdateDocument(gridItem.selectionItem.workAreaSI, autoNameFormatModel, gridItem.selectionItem.workAreaSI.filename).then(function () {
                                        //operation packet will have definition (wa pack)

                                        //Assign extraction item property values
                                        extractionservice.extractionItem.filePNE = selectionCommandResults.fileOperationPacket.fileOperations[0].destinationFile;
                                        extractionservice.extractionItem.libId = ""; //blank lib id because copy is copied out to a work area
                                        extractionservice.extractionItem.fileId = gridItem.selectionItem.workAreaSI.fileId;

                                        //defect id: 25062
                                        //changed property value set from gridItem.selectionItem to gridItem.SelectionItem.workAreaSI
                                        extractionservice.extractionItem.tableNumber = gridItem.selectionItem.workAreaSI.tableNumber;
                                        extractionservice.extractionItem.fileMajRev = gridItem.selectionItem.workAreaSI.majRev;
                                        extractionservice.extractionItem.fileMinRev = gridItem.selectionItem.workAreaSI.minRev;

                                        //promise to do the extraction for the new doc, on return update grid and show emails dialog
                                        extractionservice.extractItem(extractionservice.extractionItem, false).then(function (response) {
                                            deferred.resolve();
                                        }, function (error) {
                                            //there was an error with extractItem; close dialog and show error 
                                            deferred.resolve();
                                        });
                                     }, function (error) {
                                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, error);
                                        deferred.resolve();
                                    });
                                }
                                else {
                                    deferred.resolve();
                                }
                            }, function (response) {
                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                            });
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });
                    }
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                }); // CopyItem

            return deferred.promise;
        }

        var copyItem = function (gridItem, autoNameFormatModel) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Do a vault check, will still make calls even if not applicable.
            selectionCommandService.CheckOutVaultCheck(gridItem.selectionItem.detailedInfo.libId, gridItem.selectionItem.fileId, scope.alreadyCheckedArray).then(function (response) {
                // Process the vault check.
                zcs.ProcessFileOperationPacket(response.data, true).then(function (response) {
                    // If the vault check failed, add an error.
                    if (response != null && response.data != null && response.data.fileOperations != null && response.data.fileOperations.length > 0 && response.data.fileOperations[0].ec != 0) {
                        selectionCommandService.ErrorCode(gridItem.selectionItem, response.data.fileOperations[0].ec).then(function (response) {
                            scope.resultSLX.list.push(response.data);
                            deferred.resolve();
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });
                    }
                    else {
                        var LT_LINKED = 76; // 'L'; ApiTypes.ADLINKTYPE.LT_LINKED
                        if (gridItem.selectionItem.detailedInfo.linkType != LT_LINKED) {
                            copyItem2(gridItem, autoNameFormatModel).then(function () {
                                // When it is done, we are done.
                                deferred.resolve();
                            }, function () {
                                deferred.resolve(); // Called function will not reject.
                            });
                        }
                        else {
                            // If the document is in a Work Area, ...
                            var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
                            var O_NEW = 81; // 'Q'; // OPFLAG.O_NEW
                            var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
                            var opFlag = gridItem.selectionItem.detailedInfo.opFlag;
                            if (opFlag == O_DUP || opFlag == O_NEW || opFlag == O_OUT) {
                                selectionCommandService.GetAccessPath(gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev).then(function (data) {
                                    var filePNE = data.accessPNE;
                                    zcs.TestAccess(filePNE, true).then(function (response) {
                                        var bOK = response;
                                        if (!bOK) {
                                            var ec = 82; // ErrorCodes.ErrorCode.ECFILEBUSY
                                            selectionCommandService.ErrorCode(gridItem.selectionItem, ec).then(function (response) {
                                                scope.resultSLX.list.push(response.data);
                                                deferred.resolve();
                                            }, function (response) {
                                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                            });
                                        }
                                        else {
                                            zcs.isFile(filePNE, true).then(function (data) {
                                                if (data == true) {
                                                    copyItem2(gridItem, autoNameFormatModel).then(function () {
                                                        // When it is done, we are done.
                                                        deferred.resolve();
                                                    }, function () {
                                                        deferred.resolve(); // Called function will not reject.
                                                    });
                                                }
                                                else {
                                                    var ec = 104; // ErrorCodes.ErrorCode.EC_FILE_MISSING_FROM_WORK
                                                    selectionCommandService.ErrorCode(gridItem.selectionItem, ec).then(function (response) {
                                                        scope.resultSLX.list.push(response.data);
                                                        deferred.resolve();
                                                    }, function (response) {
                                                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                                    });
                                                }
                                            }, function (response) {
                                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                            });
                                        }
                                    }, function () {
                                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                    });
                                }, function (response) {
                                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                });
                            }
                            else {
                                copyItem2(gridItem, autoNameFormatModel).then(function () {
                                    // When it is done, we are done.
                                    deferred.resolve();
                                }, function () {
                                    deferred.resolve(); // Called function will not reject.
                                });
                            }
                        } // LINKED
                    }
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                }); // ProcessFileOperationPacket - VaultCheck
            }, function (response) {
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            }); // CheckOutVaultCheck
            // Return the promise for doing the work.
            return deferred.promise;
        };

        // Call back from the dialog.
        var questionBox_PostCloseCallback_Overwrite = function (param1, param2, result) {
            // Remember for next time.
            scope.answers.overwrite = result;
            var gridItem = param1;
            var deferred = param2;
            // If we are to process the item, ...
            if (result == 'Y' || result == 'YtoAll') {
                // Do the work now.
                copyItem(gridItem, scope.autoNameFormatModelNew).then(function () {
                    // When that is done, we are done.
                    deferred.resolve();
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            }
            else { // Or if we are not process it, ...
                // Then we are done.
                deferred.resolve();
            }
        }

        // Do one item.
        var doOne = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Get the item from the grid.
            var gridItem = list[workNumber];

            //get new gridItem name if AutoName used
            if (scope.xyz.autoNameMode == true) {
               autoNameService.GenerateAutoName($rootScope.dlgReturn.autoNameFormatModel).then(function (response) {
                    var autoNameFormatModelNew = response.data;
                    gridItem.newName = autoNameFormatModelNew.generatedName + scope.getDocExtension(gridItem.name);
                    copyItem_Control(gridItem, autoNameFormatModelNew).then(function (response) {
                        deferred.resolve();
                    }, function (response) {
                        deferred.reject();
                    });
                }, function (response) {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                });
            }
            else {
                copyItem_Control(gridItem, null).then(function (response) {
                    deferred.resolve();
                }, function (response) {
                    deferred.reject();
                });
            }
            // Return the promise for doing the work.
            return deferred.promise;
        }

        var copyItem_Control = function (gridItem, autoNameFormatModelNew) {
            // Must be a promise.
            var deferred = $q.defer();

            scope.processingLabel = loginService.resourceStrings["PROCESSING"] + " " + loginService.resourceStrings["FILENAME"] + " :  " + gridItem.selectionItem.filename + "   to   " + gridItem.newName;

            var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
            var O_NEW = 81; // 'Q'; // OPFLAG._NEW
            var O_OUT = 83; // 'S'; // OPFLAG.O_OUT

            // If src and dest are the same, just add the error and skip the 'overwrite?' question.
            // If the src is in a WA, ...
            if (gridItem.selectionItem.detailedInfo.opFlag == O_DUP
                || gridItem.selectionItem.detailedInfo.opFlag == O_NEW
                || gridItem.selectionItem.detailedInfo.opFlag == O_OUT) {
                // And the names match, ...
                if (gridItem.name == gridItem.newName
                    || gridItem.newName.length < 1) {
                    // And the work areas match, ...
                    if (gridItem.selectionItem.detailedInfo.targetId == scope.xyz.selectedWorkAreaItem.workAreaId) {
                        var ec = 83; // ErrorCodes.ErrorCode.EMCOPYSAME
                        selectionCommandService.ErrorCode(gridItem.selectionItem, ec).then(function (response) {
                            scope.resultSLX.list.push(response.data);
                            deferred.resolve();
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });
                        return deferred.promise;
                    }
                }
            }

            // This dialog has the WorkArea combo be a global. 
            // It is not applied to the row in the grid when it changes.
            var filePNE = scope.xyz.selectedWorkAreaItem.path + "\\" + gridItem.newName;

            // Collision check - local.
            zcs.isFile(filePNE, true).then(function (response) {
                var bExistsLocally = response;
                // Collision check - server.
                //checkOutService.CheckOutCollisionCheck({ filename: gridItem.newName, workAreaId: scope.xyz.selectedWorkAreaItem.workAreaId, bExistsLocally: bExistsLocally }).then(function (response) {
                //    var opFlag = response.data;           
                //    if (opFlag == O_NEW || opFlag == O_DUP) {
                selectionCommandService.CollisionCheck(scope.ACN_COPY, gridItem.selectionItem.fileId, gridItem.newName, "", scope.xyz.selectedWorkAreaItem.workAreaId, bExistsLocally).then(function (response) {
                    var collisionCheckResponse = response.data;
                    if (collisionCheckResponse.bCanOverwrite) {
                        // If YtoAll, then fall through to checkOutItem.
                        if (scope.answers.overwrite != 'YtoAll') {
                            if (scope.answers.overwrite == 'NtoAll') {
                                deferred.resolve();
                                return deferred.promise;
                            }

                            // Save AutoNameFormatModel for later use in the PostCallback routine
                            scope.autoNameFormatModelNew = autoNameFormatModelNew;
                            // Ask 'Overwrite?' with Y/N/YtoAll/NtoAll
                            // Use new name as filename.
                            // Use overwrite question - work area.
                            $rootScope.questionBoxShow(gridItem, deferred, gridItem.newName, // gridItem.selectionItem.filename,
                                loginService.resourceStrings["FILE_EXISTS_IN_WA"], // "File exists in the WorkArea.",
                                loginService.resourceStrings["OVERWRITE_QUESTION_WORKAREA"], // "Overwrite?",
                                questionBox_PostCloseCallback_Overwrite)
                            return deferred.promise;
                        }
                    }
                    copyItem(gridItem, autoNameFormatModelNew).then(function () {
                        deferred.resolve();
                    }, function () {
                        deferred.resolve(); // Called function will not reject.
                    });
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }, function () {
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });

            // Return the promise for doing the work.
            return deferred.promise;
        }

        // Walk through each item in the grid.
        var doLoop = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();

            // Do one item.
            doOne(list, workNumber).then(function () {
                // When that is done, ...
                // Incement the item number that we are going to work on.
                workNumber++;
                // If we are still in the list, ...
                if (workNumber < list.length) {
                    // Recurse on the next item.
                    doLoop(list, workNumber).then(function () {
                        // When that is done. Resolve the promise from before.
                        deferred.resolve();
                    }, function () {
                        deferred.resolve(); // Called function will not reject.
                    });
                }
                else { // We are done with the list.
                    // Resolve this item.
                    deferred.resolve();
                    // Return the promise.
                    return deferred.promise;
                }
            }, function () {
                deferred.resolve(); // Called function will not reject.
            });

            // Return the promise for the current item.
            return deferred.promise;
        }

        // On click OK.
        scope.onCopyDialogOK = function () {
            // Start working.
            scope.xyz.processing = true;
            scope.answers = {};
            scope.answers.overwrite = 'N';
            scope.resultSLX = { mode: 0, order: 0, list: [] };
            scope.alreadyCheckedArray = [];

            // Just use the combo.
            //// All items go to the same work area.
            //// Update the selection item. 
            //angular.forEach(scope.slx.list, function (item) {
            //    item.commandParams = {};
            //    item.commandParams.eWorkAreaId = scope.xyz.selectedWorkAreaItem.workAreaId;
            //});
            scope.slxContextSet = { mode: scope.slx.mode, order: scope.slx.order, list: [] };
            angular.forEach(scope.gridOptions.data, function (gridItem) {
                var si = gridItem.selectionItem;
                si.commandParams.eWorkAreaId = scope.xyz.selectedWorkAreaItem.workAreaId;
                si.commandParams.eNewName = gridItem.newName;
                scope.slxContextSet.list.push(si);
            });

            // Update the list so we can send it as a set of files involved in the command.
            // Rel engine needs to know the whole set on each item.

            zcs.isDirectory(scope.xyz.selectedWorkAreaItem.path).then(function (response) {
                if (!response) {
                    scope.xyz.processing = false;
                    $rootScope.msgBoxShow(loginService.resourceStrings["WORK_AREA_ACCESS"], "");
                    return;
                }

                // Start the loop.
                var workNumber = 0;
                doLoop(scope.gridOptions.data, workNumber).then(function () {
                    // Handle errors.
                    var slx = scope.resultSLX;
                    var atLeastOneError = false;
                    angular.forEach(slx.list, function (item) {
                        if (atLeastOneError == false) {
                            if (item.ec != 0) {
                                atLeastOneError = true;
                                if (atLeastOneError) {
                                    commandService.launchErrors({ slx: slx });
                                    //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                }
                            }
                        }
                    });

                    // Close the dialog when finished.
                    $mdDialog.hide();

                    // Done.
                    scope.xyz.processing = false;
                    gridDataService.updateGridRecords(slx.list);

                    //2018 SP1 Refactor: 20180830 - GT
                    //release plugin applications after refresh of extraction data
                    extractionservice.releasePluginApplications();

                }, function () {
                    scope.xyz.processing = false;
                });
            }, function () {
                scope.xyz.processing = false;
            });

        };

        // On click Cancel.
        scope.onCopyDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        // =====================================
        // Grid.
        // =====================================

        // Called after all rows are selected.
        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        // Called after the grid has been initialized.
        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            switch (command) {
                case "copy":
                    scope.onCopyButtonClicked(records);
                    break;
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: false,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'New Name', field: 'newName', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        // This was an old way of being called by the toolbar.
        //scope.$on('checkOutButtonClicked', function (event, arg) {
        //    scope.onCheckOutButtonClicked(arg.slx);
        //});

    }
})();
